import React, { useState } from 'react';
import { Modal, Form } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import FeedbackForm from '../forms/FeedbackForm';
import ProductionForm from '../forms/ProductionForm';
import QAForm from '../forms/QAForm';
import LoadingForm from '../forms/LoadingForm';
import TransportForm from '../forms/TransportForm';
import { isShowSelectAll } from './DepartmentHelper';

const ColumnHeader = ({
  id,
  title,
  itemCount,
  colour,
  selectedJobs,
  showAll,
  onSelectAll
}) => {
  const [show, setShow] = useState(false);
  const [jobs, setJobs] = useState([]);
  const [showAllCheck, setShowAllCheck] = useState(false);
  const [selectAllCheck, setSelectAll] = useState(false);

  const handleShowAllCheck = e => {
    showAll(e.target.checked);
    setShowAllCheck(e.target.checked);
  };

  const openBulkForm = jobs => {
    if (!jobs?.length) {
      toast.error(
        <div className="text-700 text-white">
          <h6 className="text-white">Error!</h6>
          <hr className="me-2" />
          <p>Please select at least one job before continuing!</p>
        </div>
      );
      return;
    }
    setJobs(jobs);
    setShow(true);
  };

  const renderBulkForm = () => {
    const commonProps = {
      dept: { name: title, data: colour },
      job: jobs,
      jobStageItem: { stageId: id }
    };

    switch (id) {
      case 4131:
        return <ProductionForm {...commonProps} />;
      case 4132:
        return <QAForm {...commonProps} />;
      case 4133:
        return <LoadingForm {...commonProps} />;
      case 4134:
        return <TransportForm {...commonProps} />;
      case 4135:
      case 5554:
        return <FeedbackForm {...commonProps} />;
      default:
        return null;
    }
  };

  return (
    <>
      <div
        style={{
          backgroundColor: colour,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start'
        }}
        className="light kanban-column-header"
      >
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            width: '100%'
          }}
        >
          <h5 className="fs-0 mb-0 py-2">
            {title} <span className="text-800">({itemCount})</span>
          </h5>
          <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
            {/* {(id === 4135 || id === 5554) && ( */}
            {isShowSelectAll(id) && (
              <button
                className="m-0 rounded-2 shadow py-1 px-2 bg-soft-secondary border-0 float-end text-800"
                onClick={async () => openBulkForm(selectedJobs)}
              >
                Bulk Complete
              </button>
            )}

            {id === 4126 && (
              <div className="mt-2">
                <Form.Check
                  id="showAllCusts"
                  type="checkbox"
                  label="Show All"
                  checked={showAllCheck}
                  onChange={e => handleShowAllCheck(e)}
                />
              </div>
            )}
          </div>
        </div>
        {onSelectAll && (
          <div className="mt-2">
            <Form.Check
              id="selectAllCheck"
              type="checkbox"
              label="Select All"
              checked={selectAllCheck}
              onChange={e => {
                setSelectAll(e.target.checked);
                onSelectAll(e.target.checked);
              }}
            />
          </div>
        )}
      </div>

      <Modal size="xl" show={show} onHide={() => setShow(false)}>
        <Modal.Body>
          <div id={`form-${id}`}>{renderBulkForm()}</div>
        </Modal.Body>
      </Modal>
    </>
  );
};

ColumnHeader.propTypes = {
  id: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  itemCount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  colour: PropTypes.string,
  selectedJobs: PropTypes.arrayOf(PropTypes.object),
  showAll: PropTypes.func.isRequired,
  onSelectAll: PropTypes.func
};

export default ColumnHeader;
